import { render, staticRenderFns } from "./btnGroup.vue?vue&type=template&id=7045cabf&scoped=true"
import script from "./btnGroup.vue?vue&type=script&lang=js"
export * from "./btnGroup.vue?vue&type=script&lang=js"
import style0 from "./btnGroup.vue?vue&type=style&index=0&id=7045cabf&prod&lang=less&scoped=true"
import style1 from "./btnGroup.vue?vue&type=style&index=1&id=7045cabf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045cabf",
  null
  
)

export default component.exports